module.exports = __webpack_public_path__ + "img/animal-crossing-logo-high-def.dc904213.png";